import * as K from './CategoriesConstants';
import Fuse from 'fuse.js';

import floopback from '../../../lib/floopback';
var Categories = new floopback('categories');

export function find(params) {
    let _this = this;
    return (dispatch, getState) => {
        dispatch({
            type: K.FIND,
            payload: Categories.find({ params })
        }).then(function(result) {
            _this.searchTable(getState().Categories.search);
        });
    };
}

export function findById(id) {
    return (dispatch, getState) => {
        dispatch({
            type: K.FIND_BY_ID,
            payload: Categories.findById(id)
        });
    };
}

export function create(formData) {
    return (dispatch, getState) => {
        return new Promise(function(resolve, reject) {
            dispatch({ type: K.CREATE + '_PENDING', payload: formData });
            Categories.create(formData)
                .then(function(data) {
                    dispatch({ type: K.CREATE + '_FULFILLED', payload: data });
                    resolve(data);
                })
                .catch(function(error) {
                    dispatch({ type: K.CREATE + '_REJECTED', payload: error });
                    reject(error);
                });
        });
    };
}

export function update(id, formData) {
    return (dispatch, getState) => {
        return new Promise(function(resolve, reject) {
            dispatch({ type: K.UPDATE + '_PENDING', payload: formData });
            Categories.update(id, formData)
                .then(function(data) {
                    dispatch({ type: K.UPDATE + '_FULFILLED', payload: data });
                    resolve(data);
                })
                .catch(function(error) {
                    dispatch({ type: K.UPDATE + '_REJECTED', payload: error });
                    reject(error);
                });
        });
    };
}

export function remove(id) {
    return (dispatch, getState) => {
        return new Promise(function(resolve, reject) {
            dispatch({ type: K.DELETE + '_PENDING' });
            Categories.delete(id)
                .then(function(data) {
                    dispatch({ type: K.DELETE + '_FULFILLED', payload: data });
                    resolve(data);
                })
                .catch(function(error) {
                    dispatch({ type: K.DELETE + '_REJECTED', payload: error });
                    reject(error);
                });
        });
    };
}

export function changeTable(feature, value) {
    return (dispatch, getState) => {
        dispatch({
            type: K.CHANGE_TABLE,
            payload: {
                feature: feature,
                value: value
            }
        });
    };
}

export function searchTable(search) {
    return (dispatch, getState) => {
        var options = {
            threshold: 0.4,
            location: 0,
            distance: 100,
            maxPatternLength: 32,
            minMatchCharLength: 1,
            keys: ['id', 'email', 'client.nombre', 'tipo']
        };

        var fuse = new Fuse(getState().Categories.data, options);
        let result = fuse.search(search);

        dispatch({
            type: K.SEARCH_TABLE,
            payload: {
                search: search,
                searchData: result
            }
        });
    };
}



// WEBPACK FOOTER //
// ./src/views/Categories/redux/CategoriesActions.jsx